/** Extracts the AIM envelope message retained on Angular HttpErrorResponse. */
export function caseApiErrorMessage(error: unknown, fallback: string): string {
  const responseMessage = (
    error as { error?: { result?: { message?: unknown } } }
  )?.error?.result?.message;
  if (typeof responseMessage === 'string' && responseMessage.trim()) {
    return responseMessage;
  }
  return error instanceof Error && error.message ? error.message : fallback;
}

/** Reads an HTTP status without coupling Care Plan state to Angular HTTP. */
export function caseApiErrorStatus(error: unknown): number | null {
  const status = (error as { status?: unknown })?.status;
  return typeof status === 'number' ? status : null;
}
